// extracted by css-extract-rspack-plugin
export default {"reactionsContainer":"Reactions-module__reactionsContainer__bVzf1"};